<template>
  <div class="original" >
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem to="/classify/classifylist">智能归类 </BreadcrumbItem>
        <BreadcrumbItem>智能归类详情 </BreadcrumbItem>
      </Breadcrumb>
    </div>

    <div class="card_div boxshadow1" style="  font-size:16px;   width: 1400px;
    margin: 20px auto;
    padding: 20px;
    min-height: calc(100vh - 300px);">
    <div class="title">
      <label
        >商品编码：{{
          $route.query.hsCode
        }}</label
      >
     
    </div>
    <div>
      <Card
       
        v-for="(item, index) in merchandiseData"
        :key="index"
      >
        <div class="header">
          <label><!-- 申报名称 -->申报名称 </label>
          <span>{{ item.dataName }}</span>
        </div>
        <div class="header artic">
          <label><!-- 申报要素 -->申报要素</label>
          <span>{{ item.description }}</span>
          <!-- declaration -->
        </div>
      </Card>
    </div> </div>
  </div>
</template>

<script>

// // 权限判断函数

export default {
  name: "detailShop",
  data() {
    return {
      PageIndex: 1,
      list: [], //列表
      merchandiseData: [],
     
      listLoading: false,
      height: "",
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      modelData: {}
    };
  },
  methods: {
    typeOfcode(nubmer) {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (
        regPos.test(nubmer) ||
        regNeg.test(nubmer) ||
        nubmer.indexOf("%") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
 
    getMerchandiseData() {
    
      this.$api.classify.getclassifyDetail(this.$route.query.sourceid, {
        success: response => {
       
          if (response.data.code =="200") {
            this.merchandiseData = response.data.data.classHistorySourceResult;
          }
        },
        error: errorMsg => {
          this.isShowModalLoader = false
          this.searching = false
          this.$Message.error({content: this.$t('common.tryAgain'), duration: 1.5, closable: true})
          this.$Loading.error()
        }
      })
     
    },
    //弹出
    openModel(flag, item) {
      eval(flag + "= true");
      this.modelData = item;
    }
  },
  created() {
    this.getMerchandiseData()
  },
  mounted() {
 
  }
};
</script>

<style  scoped>
.original {
  font-size: 12px;
}
.title {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  label {
    flex: 1;
   
  }
  .fr {
    text-align: right;
    .el-button {
      font-size: 12px;
    }
  }
}
.ivu-card-body  .header {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-size:16px;
 
  span {
    flex: 1;
  }
}
.ivu-card:hover {
   -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
   box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); 
   border: 1px solid #ebeef5;
}
.ivu-card {
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: .3s;
  transition: .3s;
  margin-bottom: 20px;
}
.ivu-card-body{
  margin-bottom: 10px;
}
.ivu-card-body  i {
  color: #9b9b9b;
  margin-right: 5px;
}
.ivu-card-body .artic {
  line-height: 20px;
}
.ivu-card-body .header  label {
  background-color: #e6f7fe;
  border: 1px solid #cceffc;
  display: inline-block;
  color: #00aef0;
  width: 90px;
  height: 30px;
  font-size:16px;
  line-height: 30px;
  margin-right: 15px;
  text-align: center;
  border-radius: 4px;
}

</style>




// WEBPACK FOOTER //
// src/components/Classify/ClassifyDetail.vue